import { ScoreboardType } from '../../../../enums/scoreboardTypes';
import SchoolTab from './school/SchoolTab';
import ClassesTab from './classes/ClassesTab';
import StudentsTab from './students/StudentsTab';

export const tabRegistry = {
  [ScoreboardType.SCHOOL]: SchoolTab,
  [ScoreboardType.CLASSES]: ClassesTab,
  [ScoreboardType.STUDENTS]: StudentsTab,
};

